module.exports = __webpack_public_path__ + "img/绵阳市第三人民医院.79246782.png";